import * as React from "react";
import { IInputImageIconProps } from ".";

export const InputImageIcon: React.FC<IInputImageIconProps> = ({ src, ...props }) => {
    return <div className="tmp-image-icon" style={{ backgroundImage: "url('" + src + "')" }} />;
};
